"use strict";
/*
 * Created on 15. 7. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var OptimizationGraphData_1 = require("./OptimizationGraphData");
/**
 * DTO for optimization graph (LOG-3113).
 * @author Radek Beran
 */


var OptimizationGraph =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(OptimizationGraph, _DomainObject_1$Domai);

  function OptimizationGraph(message, optimizationId, result) {
    var _this;

    _classCallCheck(this, OptimizationGraph);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimizationGraph).call(this));
    _this.message = message;
    _this.optimizationId = optimizationId;
    _this.result = result;
    return _this;
  }

  return OptimizationGraph;
}(DomainObject_1.DomainObject);

exports.OptimizationGraph = OptimizationGraph;

OptimizationGraph.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(OptimizationGraph.name);
  return {
    message: builder.str('message'),
    optimizationId: builder.str('optimizationId'),
    result: builder.opt(builder.obj('result', OptimizationGraphData_1.OptimizationGraphData.schema, function (mat) {
      return new OptimizationGraphData_1.OptimizationGraphData(mat.points, mat.pointsInPercent, mat.actualData, mat.optimalMargins);
    }))
  };
}();